module.exports = __webpack_public_path__ + "static/media/junte e ganhe.32357b0a.png";